
export default {
  props: {
    faq: {
      type: Array,
      default: () => [
        {
          question: null,
          answer: null,
          isCollapsed: false,
        },
      ],
    },
  },
};
